import { Landmark } from "lucide-react";

export const fmtAcc = (a) => (a || "").replace(/\D/g, "").replace(/^(\d{2})(\d+)$/, (_, c, r) => `${c} ${r.replace(/(\d{4})(?=\d)/g, "$1 ")}`);

export const WlAccounts = ({ list, testid, checkedAt }) => (
  <div className="rounded border border-border bg-zinc-50 px-2 py-1.5" data-testid={testid}>
    <p className="text-[11px] text-zinc-500 flex items-center gap-1"><Landmark className="h-3 w-3" />Konta na białej liście ({list.length}){checkedAt ? ` · ${new Date(checkedAt).toLocaleDateString("pl-PL")}` : ""}</p>
    <ul className="mt-0.5 max-h-24 overflow-y-auto">
      {list.map((a) => <li key={a} className="text-xs font-mono tabular-nums break-all" data-testid={`${testid}-item`}>{fmtAcc(a)}</li>)}
    </ul>
  </div>
);
